// src/contexts/MockReviewsContext.js
import React, { useState } from "react";

// Create the context
export const MockReviewsContext = React.createContext();

// Create the provider component
export const MockReviewsProvider = ({ children }) => {
  // State for view ("Rating" or "Sales")
  const [view, setView] = useState("Rating"); // Default to "Rating"

  // State for other context properties
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  // Mock functions (if needed, replace with actual implementations)
  const setSelectedAttribute = () => {};

  // Context value to be provided to consumers
  const mockReviews = {
    selectedCategory,
    setSelectedCategory,
    selectedSubject,
    setSelectedSubject,
    selectedDate,
    setSelectedDate,
    view,
    setView, // Provide setView to allow updates
    setSelectedAttribute, // If this is needed elsewhere
  };

  return (
    <MockReviewsContext.Provider value={mockReviews}>
      {children}
    </MockReviewsContext.Provider>
  );
};
